import { useTranslation } from "react-i18next";
import {
  Box,
  Divider,
  Rating,
  styled,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import React from "react";
import CheckIcon from "@icons/check.svg?react";
import { SupportCard } from "@features/cashbackWizard2.0/components/SupportCard";
import { SupportCardAnonymous } from "@features/cashbackWizard2.0/components/SupportCardAnonymous";
import { EmailSupportLink } from "@rentablo/components";
import { PhoneSupportLink } from "./PhoneSupportLink";

const StyledCheckIcon = styled(CheckIcon)(({ theme }) => ({
  color:
    theme.type === "onvista"
      ? theme.palette.text.primary
      : theme.palette.primary.dark,
}));

export const RateSupport = ({
  showAnonymousSupport = false,
}: {
  showAnonymousSupport?: boolean;
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box textAlign="center">
      <Divider sx={{ margin: theme.spacing(11, 0, 8, 0) }} />
      <Box
        display="flex"
        justifyContent="space-between"
        flexDirection={isMobile ? "column" : "row"}
      >
        <Box textAlign="center" my={3} flexBasis="33.3%">
          <Box display="flex" justifyContent="center">
            <StyledCheckIcon />
            <Typography
              variant="body3"
              ml={1}
              mb={1}
              color="textPrimary"
              sx={{ marginLeft: theme.spacing(2) }}
              noWrap
            >
              {t("cashbackWizard.rateSupport.professionalism")}
            </Typography>
          </Box>
          <Rating
            max={5}
            value={5}
            icon={<StarIcon fontSize="inherit" color="primary" />}
            emptyIcon={<StarOutlineIcon fontSize="inherit" />}
            readOnly
          />
        </Box>

        <Box textAlign="center" my={3} flexBasis="33.3%">
          <Box display="flex" justifyContent="center">
            <StyledCheckIcon />
            <Typography
              variant="body3"
              ml={1}
              mb={1}
              color="textPrimary"
              sx={{ marginLeft: theme.spacing(2) }}
              noWrap
            >
              {t("cashbackWizard.rateSupport.customerSatisfaction")}
            </Typography>
          </Box>
          <Rating
            max={5}
            value={5}
            icon={<StarIcon fontSize="inherit" color="primary" />}
            emptyIcon={<StarOutlineIcon fontSize="inherit" />}
            readOnly
          />
        </Box>

        <Box textAlign="center" my={3} flexBasis="33.3%">
          <Box display="flex" justifyContent="center">
            <StyledCheckIcon />
            <Typography
              variant="body3"
              ml={1}
              mb={1}
              color="textPrimary"
              sx={{ marginLeft: theme.spacing(2) }}
              noWrap
            >
              {t("cashbackWizard.rateSupport.customerLoyalty")}
            </Typography>
          </Box>
          <Rating
            max={5}
            value={5}
            icon={<StarIcon fontSize="inherit" color="primary" />}
            emptyIcon={<StarOutlineIcon fontSize="inherit" />}
            readOnly
          />
        </Box>
      </Box>
      <Box>
        <Typography variant="caption" mt={3} mb={11} color="text.tertiary">
          {t("cashbackWizard.rateSupport.reviews", { value: 57 })}
        </Typography>
      </Box>
      <Box my={5} display="flex" flexDirection="column" alignItems="center">
        {showAnonymousSupport ? (
          <SupportCardAnonymous align="center" />
        ) : (
          <SupportCard align="center" />
        )}
        <Box mt={5}>
          <PhoneSupportLink variant="extended" mb={2} />
          <EmailSupportLink variant="extended" />
        </Box>
      </Box>
    </Box>
  );
};
